import Vue from 'vue'
import Vuex from 'vuex'
import Profile from "./modules/Profile/Profile"
import ActivityType from "./modules/ActivityType/activity_type"
import Person from "./modules/Person/person"
import Gantt from "./modules/Gantt/gantt"
import PersonRe from "./modules/Person/personre"
import PersonRest from "./modules/Person/personrest"
import PersonPodr from "./modules/Person/personpodr"
import Persongid from "./modules/Persongid/persongid"
import Fund from "./modules/Fund/fund"
import Manne from "./modules/Manne/manne"
import Frund from "./modules/Frund/frund"
import Eve from "./modules/Eve/eve"
import Tags from "./modules/Tags/tags"
import ContactType from "./modules/Type/type"
import CostType from "./modules/Cost/type"
import GanttType from "./modules/Gantt/type"
import PhoneEmailType from "./modules/Type/phoneEmailType"
import Owner from "./modules/Owner/owner"
import Pay from "./modules/Pay/pay"

import Inrest from "./modules/Inrest/inrest"
import Museum from "./modules/Museum/museum"

import Language from './modules/Language/language'

import Currency from "./modules/Currency/currency"

import Zal from "./modules/Zal/zal"
import Inv from "./modules/Inv/inv"
import Fundtype from "./modules/Fundtype/fundtype"
import Mannetype from "./modules/Mannetype/mannetype"
import Mannecate from "./modules/Mannetype/mannecate"
import WarehouseType from "./modules/WarehouseType/warehouseType"
import Yesno from "./modules/Yesno/yesno"
import Restorer from "./modules/Restorer/restorer"



import Age from "./modules/Age/age"
import Sex from "./modules/Sex/sex"
import Traf from "./modules/Traf/traf"

import Status from "./modules/Status/status"
import Additional from "./modules/Additional/additional"
import Pipeline from "./modules/Pipeline/pipeline"
import PipelineListByMuseum from "./modules/Pipeline/pipelinesbymuseum"
import Stage from "./modules/Stage/stage"
import Organization from "./modules/Organization/organization";

import Argon from "./modules/Argon/argon";

import Example from './modules/Example';
import Deal from './modules/Deal/deals';
import Notification from './modules/Setting/notification'
import CheckEmailSetting from './modules/Setting/checkEmailDeliverySetting';
import {formatted_date, formatted_time} from "../Helpers/helpers";
import PipelineTicketType from "./modules/PipelineTiketType/pipelineTicketType";
// import museum from './modules/Museum/museum'

Vue.use(Vuex);


export default new Vuex.Store({
    state: {
        loading: false,
        settings: {
            dateFormat: formatted_date(),
            timeFormat: parseInt(formatted_time()),
        },
        theme: {
            darkMode: false
        }

    },
    mutations: {
        SET_LOADER(state, data){
            state.loading = data;
        }
    },
    modules: {
        PipelineListByMuseum,
        PipelineTicketType,
        Currency,
        Language,
        CostType,
        Gantt,
        GanttType,
        WarehouseType,
        Profile,
        ActivityType,
        Person,
        PersonRe,
        PersonRest,
        PersonPodr,
        Persongid,
		Fund,
		Manne,
		Frund,
		Eve,
        Tags,
        ContactType,
        PhoneEmailType,
        Owner,
        Pay,
        Inrest,
        Museum,
        Yesno,
        Restorer,
        Zal,
        Inv,
        Fundtype,
        Mannetype,
        Mannecate,
        Age,
        Sex,
        Traf,
        Status,
        Additional,
        Pipeline,
        Stage,
        Organization,
        Argon,
        Example,
        Deal,
        Notification,
        CheckEmailSetting
    }
});
